export default __webpack_public_path__ + "static/media/einstein.a689ceb1.svg";